import { useEffect } from "react";
export function getExtension(filename: string | undefined) {
  if (!filename) return "";
  var parts = filename.split("/");
  return parts[parts.length - 1];
}
